import { IIAMGroup } from "api/entities/iam-groups";
import SidePanelSection from "components/shared-ui/side-panel-section/side-panel-section";
import { useApi } from "utils/hooks/use-api";
import { iamService } from "api/services/iam";
import React, { useEffect } from "react";
import { Chip, Stack } from "@mui/material";
import Button from "components/shared-ui/button";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import styles from "./group-section.module.scss";
import { routeUtils } from "utils/route-utils";
import IAMEntitySearch from "components/shared-ui/iam/sections/entity-search/entity-search";
export interface IGroupSectionProps {
  groups: IIAMGroup[];
  //   autofocus?: boolean;
  onChange?: (groups: IIAMGroup[]) => void;
  isCreate?: boolean;

  onNewGroupClick?: () => void;
  //   errors?: {};
  //   onError?: (errors: {}) => void;
}

interface ChipData {
  key: number;
  label: string;
}

export default function GroupSection(props: IGroupSectionProps) {
  const [api, isLoading] = useApi();
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<IIAMGroup[]>([]);
  const [selected, setSelected] = React.useState<IIAMGroup[]>([]);

  const navigate = useNavigate();

  const fetchData = () => {
    api(iamService.getGroups().then((page) => setOptions(page.data)));
  };

  const handleDelete = (groupToDelete: IIAMGroup) => {
    setSelected((prev) =>
      prev.filter((val) => val.GroupName !== groupToDelete.GroupName)
    );
  };

  useEffect(() => {
    if (!open) return;
    fetchData();
  }, [open]);

  useEffect(() => {
    props.onChange?.(selected);
  }, [selected]);

  useEffect(() => {
    setSelected(props.groups);
  }, [props.groups]);

  return (
    <SidePanelSection testId="group-section" title="Assigned Groups">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          gap: "14px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <IAMEntitySearch
            isLoading={isLoading}
            placeHolderText="Add User to Groups"
            value={selected}
            options={options}
            getOptionLabel={(option) => option.GroupName}
            isOptionEqualToValue={(option, value) =>
              option.GroupName === value.GroupName
            }
            onChange={(newValue) => {
              setSelected(newValue as IIAMGroup[]);
            }}
            onOpen={fetchData}
          />
          <Button
            testId="new-group-link"
            colors="primary"
            onClick={() => props.onNewGroupClick?.()}
          >
            <AddIcon />
          </Button>
        </div>

        <Stack
          direction="row"
          spacing={2}
          useFlexGap
          flexWrap="wrap"
          style={{ height: 30 }}
        >
          {selected.map((group) => (
            <Chip
              className={`${!props.isCreate && styles["chip-clickable"]}`}
              size="medium"
              key={group.GroupName}
              label={group.GroupName}
              sx={{
                flexDirection: "row",
                fontSize: "1rem",
                alignItems: "center",
                height: 30,
                px: 2,
                "& .MuiChip-label": {},
                "& .MuiChip-deleteIcon": {
                  height: 18,
                  width: 18,
                  backgroundColor: "inherit",
                  ":hover": {
                    backgroundColor: "white",
                  },
                },
              }}
              onClick={
                !props.isCreate
                  ? () => {
                      navigate(
                        routeUtils.getRouteToIAMGroupDetails(group.GroupName)
                      );
                    }
                  : undefined
              }
              onDelete={() => {
                handleDelete(group);
              }}
            />
          ))}
        </Stack>
      </div>
    </SidePanelSection>
  );
}
